import { render, staticRenderFns } from "./EditProjectGroupDialog.vue?vue&type=template&id=35e5ad84&"
import script from "./EditProjectGroupDialog.vue?vue&type=script&lang=ts&"
export * from "./EditProjectGroupDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports